import * as DealTableActions from "./DealTableActions";

export default DealTableActions;



// WEBPACK FOOTER //
// ./src/actions/DealTableActions/index.js